import NewAssetsTable from './NewAssetsTable';

export default NewAssetsTable;
